import React from 'react';
import { LessThanMedium, Medium } from '@justgiving/responsive';
import { Navigation } from 'components/Navigation';
import PersonalDetails from 'pages/Personal';

const Index = () => (
  <div>
    <Medium>
      <PersonalDetails />
    </Medium>
    <LessThanMedium>
      <div className="jg-background--white">
        <h1 className="jg-space-ptmd jg-space-phsm jg-space-pbsm qa-page__heading">
          Account &amp; preferences
        </h1>
        <Navigation />
      </div>
    </LessThanMedium>
  </div>
);

export default Index;
